var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.contentItems.length)?_c('div',{staticClass:"content-items"},_vm._l((_vm.contentItems),function(content){return _c('router-link',{key:content.id,staticClass:"content-items__link",attrs:{"to":_vm.localePath({ path: `/registration/juridical/${content.id}` }),"target":"_blank"}},[_vm._v(" "+_vm._s(content.name)+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }